// extracted by mini-css-extract-plugin
module.exports = {"helpText":"OrderScreen_helpText__2mF5W"};